import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export function AuthShell({ eyebrow, title, subtitle, children, footer, testid }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 relative overflow-hidden landing-bg" data-testid={testid}>
      <div className="absolute inset-0 grain pointer-events-none" />
      <motion.div
        initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45, ease: "easeOut" }}
        className="relative z-10 w-full max-w-md"
      >
        <Link to="/" className="flex items-center gap-3 mb-8" data-testid="auth-brand-link">
          <div className="w-10 h-10 gradient-gold rounded-md flex items-center justify-center">
            <span className="font-display text-black text-xl font-bold">C</span>
          </div>
          <div>
            <div className="font-display text-xl tracking-tight">Clara Deals</div>
            <div className="overline text-[9px] text-white/40 mt-0.5">M&A Intelligence</div>
          </div>
        </Link>
        <div className="backdrop-blur-2xl rounded-lg p-7 md:p-9" style={{ background: "rgba(11,21,48,0.72)", border: "1px solid rgba(197,160,89,0.22)" }}>
          {eyebrow && <div className="overline text-[9px] text-gold mb-2">{eyebrow}</div>}
          <h1 className="font-display text-3xl tracking-tight leading-tight mb-2">{title}</h1>
          {subtitle && <p className="text-sm text-white/50 mb-7 leading-relaxed">{subtitle}</p>}
          {children}
        </div>
        {footer && <div className="text-center mt-6 text-[12px] text-white/45">{footer}</div>}
      </motion.div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block mb-4">
      <span className="block text-[11px] uppercase tracking-[0.14em] text-white/45 mb-1.5">{label}</span>
      {children}
    </label>
  );
}

export function FormError({ msg }) {
  if (!msg) return null;
  return <div className="mb-4 px-3 py-2 rounded-md text-[12.5px] text-red-300 bg-red-500/10 border border-red-500/30" data-testid="auth-error">{msg}</div>;
}

export function FormNotice({ msg }) {
  if (!msg) return null;
  return <div className="mb-4 px-3 py-2 rounded-md text-[12.5px] text-emerald-300 bg-emerald-500/10 border border-emerald-500/30" data-testid="auth-notice">{msg}</div>;
}

export function SubmitButton({ loading, children, testid }) {
  return (
    <button type="submit" disabled={loading} data-testid={testid}
      className="w-full py-3 rounded-md bg-[#C5A059] text-black font-medium text-sm hover:bg-[#D4AF37] transition-colors disabled:opacity-60">
      {loading ? "Please wait…" : children}
    </button>
  );
}
